import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "sedan"
const SedanIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 8.5h7l7 3.5h2a2 2 0 0 1 2 2v2h-2.18c-.42 1.2-1.55 2-2.82 2-1.27 0-2.4-.8-2.83-2H7.82C7.4 17.2 6.27 18 5 18c-1.27 0-2.4-.8-2.83-2H1v-4.445a1 1 0 0 1 .47-.849L5 8.5Zm.5 1.5-2.948 2H15.5l-4-2h-6Zm.56 3.94a1.5 1.5 0 1 0-2.12 2.12 1.5 1.5 0 0 0 2.12-2.12Zm13 0a1.5 1.5 0 1 0-2.12 2.12 1.5 1.5 0 0 0 2.12-2.12Z"
      />
    </svg>
  )
}
export default SedanIcon
